"use strict";

var _interopRequireDefault = require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _order = require("@/api/order");
var _cropUpload = _interopRequireDefault(require("@/components/cropUpload"));
var _default = {
  components: {
    cropUpload: _cropUpload.default
  },
  props: ['item'],
  data: function data() {
    return {
      dialogVisible: false,
      formData: {},
      defaultForm: {
        evidence_url: '',
        merchant_remark: ''
      },
      rules: {
        evidence_url: [{
          required: true,
          message: '请上传图片',
          trigger: 'change'
        }]
      }
    };
  },
  watch: {
    dialogVisible: function dialogVisible(val) {
      if (val) {
        console.log('item', this.item);
        if (0) {} else {
          this.formData = this.$func.deepClone(this.defaultForm);
        }
      } else {
        this.$refs['formData'].resetFields();
      }
    }
  },
  methods: {
    setUrl: function setUrl(val) {
      this.formData.evidence_url = val;
    },
    submit: function submit() {
      var _this = this;
      // this.$confirm("您确定要申请扣款吗？", "申请扣款", {
      // 	confirmButtonText: '确定',
      // 	cancelButtonText: '取消'
      // }).then(() => {
      this.$refs['formData'].validate(function (valid) {
        if (valid) {
          var param = (0, _objectSpread2.default)({
            order_id: _this.item.order_id,
            lease_id: _this.item.id
          }, _this.formData);
          console.log('param', param);
          (0, _order.applyWithhold)(param).then(function (res) {
            _this.$emit('success');
            _this.close();
          }).catch(function () {});
        }
      });
    },
    close: function close() {
      this.dialogVisible = false;
    }
  }
};
exports.default = _default;